module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.99/js/sprocket_orange.svg"